module.exports = __webpack_public_path__ + "static/media/mark-vc.db3b26e4.svg";